const languages = {
  en: "English",
  id: "Bahasa",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  zh: "简体中文",
  fa: "فارسی",
}

export default languages